import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import defaultStyles from './products-info-bar-view.scss';

type OrderBy = 'updated' | 'creation' | 'price';

export interface Props {
    styles: typeof defaultStyles;
    productsCount: number;
    hasActiveFilters?: boolean;
    orderBy: OrderBy;
}

class ProductsInfoBarView extends React.PureComponent<Props> {
    render() {
        const { styles, productsCount, hasActiveFilters, orderBy } = this.props;

        const orderByTranslations: { [k in OrderBy]: React.ReactNode } = {
            updated: <FormattedMessage id='BAZAAR_ORDER_UPDATED_TITLE' />,
            creation: <FormattedMessage id='BAZAAR_ORDER_CREATED_TITLE' />,
            price: <FormattedMessage id='BAZAAR_ORDER_PRICE_TITLE' />,
        };

        return (
            <div className={styles.infoBar}>
                <h2 className={styles.secondaryTitle}>
                    {orderByTranslations[orderBy] || (
                        <>
                            <FormattedMessage id='BAZAAR_ORDER_UPDATED_TITLE' />
                            &nbsp;
                        </>
                    )}
                    {hasActiveFilters ? <FormattedMessage id='BAZAAR_IN_ACTIVE_FILTERS' /> : ''}
                    <FormattedMessage id='%(counter)s_ENTRIES' values={{ counter: productsCount }}>
                        {message => <span className={styles.element}>({message})</span>}
                    </FormattedMessage>
                </h2>
                {this.props.children}
            </div>
        );
    }
}

export default Styled(defaultStyles)(ProductsInfoBarView);
